import "./Main.scss";
import Services from "../Services/Services";
import Slider from "../SlickSlider/Slider";
import About from "../About/About";
import Blog from "../Blog/BlogPage";
// import Scroll from "../../assets/ScrollUpButton/index";
import Production from "../Production/Production";
import SliderPartners from "../SliderPartners/SliderPartners";
import FAQ from "../FAQ/main/FAQ";
import Feedback from "../Feedback/Feedback";
import PrivacyPopup from "../PrivacyPopUp/PrivacyPopup";
import { Helmet } from "react-helmet";
import React from "react";

export default function Main() {

    return (
        <main className="main">
            <Helmet>
                <title>Санберрі Україна • Добрива від виробника | Sunberry Ukraine</title>
                <link rel="canonical" href="https://sun-ukr.com" />
                <meta name="keywords" content="Sunberry Ukraine, Виробництво, Інновації, Санберрі Україна, Агроболік, Агронеїн, NPK, добрива" />
                <meta name="description" content="🌱 Санберрі Україна виготовляє  органо-мінеральні добрива індивідуального складу ⭐ Займаємось комплексним вирощуванням сільськогосподарських культур, починаючи підбором найкращого насіння, закінчуючи реалізацією продукції."></meta>
            </Helmet>
            <div className="main__container">
                {/* <Scroll /> */}
                <section className="slider">
                    <Slider />
                </section>
                <section className="about">
                    <About />
                </section>
                <section className="production">
                    <Production />
                </section>
                <Services />
                <SliderPartners />
                <Blog />
                <FAQ />
                <PrivacyPopup />
                <section className="Feedback" id="section5">
                    <Feedback />
                </section>
            </div>
        </main>
    );
}